module.exports = __webpack_public_path__ + "static/media/Lgpd.1a480b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lives/Lgpd.png
// module id = 306
// module chunks = 0